import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import BottomNavbar from "../../component/common/BottomNavbar";
import Header from "../../component/common/Header";
import BestMenu from "../../component/report/BestMenu";
import BiggestDiffMenu from "../../component/report/BiggestDiffMenu";
import CompPredictSales from "../../component/report/CompPredictSales";
import PredictSales from "../../component/report/PredictSales";
import TodaySales from "../../component/report/TodaySales";
import usePageInfo from "../../hooks/usePageInfo";
import useSalesData from "../../hooks/useSalesData";
import { motion } from "framer-motion";
import DropDownMenu from "../../component/common/DropDownMenu";
import UserRank from "../../component/report/UserRank";
import CalendarContent from "../../component/common/CalendarContent";
import LoadingScreen from "../../component/common/LoadingScreen";
import { useTranslation } from "react-i18next";
import NoData from "../../component/report/NoData";
import useRankingData from "../../hooks/useRankingData";
import { totalThunks } from "../../store/salesApiSlice";
import { fetchRanking } from "../../store/slices/rankingSlice";
import Newbie from "../../component/report/Newbie";
import useNewbieData from "../../hooks/useNewbieData";
import { isTokenExpired } from "../../functions/CheckToken";

function ReportPage(props) {
  const navType = useNavigationType();
  const location = useLocation();

  const { t, i18n } = useTranslation();
  const sideList = Object.values(t("sideList", { returnObjects: true }));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page] = usePageInfo(props.page);
  const {
    todayDate,
    currentDate,
    isLoadingState,
    todayValue,
    predictValue,
    rankDetailValue,
    rankCompareValue,
    menuObject,
    lastDetailValue,
    validDateList,
  } = useSalesData();
  const [componentFade, setComponentFade] = useState([
    true,
    true,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [leftSide, setLeftSide] = useState(false);
  const [rightSide, setRightSide] = useState(false);
  const [topVisible, setTopVisible] = useState(false);
  const {
    rankDetailValue: userRankDetail,
    lastDetailValue: userLastDetail,
    isLoadingState: userLoading,
  } = useRankingData();

  const {
    visitDetailValue,
    currentDate: newbieDate,
    isLoadingState: newbieLoading,
  } = useNewbieData();
  useEffect(() => {
    const token = sessionStorage.getItem("accessToken");
    const is_expired = isTokenExpired(token);
    if (!token || is_expired === true) {
      window.alert("데이터 최신화를 위해 재로그인을 시도합니다.");
      navigate("/login");
      return;
    }
  }, [dispatch, navigate]);

  const changeLanguage = (type) => {
    if (i18n.language === "en" && type === "ko") {
      i18n.changeLanguage("ko");
    } else if (i18n.language === "ko" && type === "en") {
      i18n.changeLanguage("en");
    }
    setLeftSide(false);
  };
  const handleScrollTop = () => {
    if (window.scrollY > 500) {
      setTopVisible(true);
    } else {
      setTopVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScrollTop);
    return () => {
      window.removeEventListener("scroll", handleScrollTop);
    };
  }, []);

  const handleScroll = () => {
    const items = document.querySelectorAll(".report-item");
    items.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      if (rect.top < window.innerHeight / 2 && !componentFade[index]) {
        setComponentFade((prev) => {
          const newVisibleItems = [...prev];
          newVisibleItems[index] = true;
          return newVisibleItems;
        });
      }
    });
  };
  const scrollToContent = (index) => {
    const items = document.querySelectorAll(".report-item");
    if (index >= 0 && index < items.length) {
      // 유효한 인덱스인지 확인
      setLeftSide(false);
      const elementPosition =
        items[index].getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - 66;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    } else {
      console.error("유효하지 않은 인덱스입니다."); // 유효하지 않은 인덱스일 경우 에러 메시지 출력
    }
  };
  const openLeftSide = () => {
    if (rightSide) {
      setRightSide(false);
    }
    setLeftSide(!leftSide);
  };
  const openRightSide = () => {
    if (leftSide) {
      setLeftSide(false);
    }
    setRightSide(!rightSide);
  };

  {
    /*}
  useEffect(() => {
    window.scrollTo(0, 0);
    setComponentFade([true, true, false, false, false, false, false]);
  }, [props.page]);
*/
  }

  {
    /*스크롤 유지 기능!!*/
  }

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    const saveScroll = () => {
      sessionStorage.setItem(
        `scroll-pos-${location.pathname}`,
        String(window.scrollY)
      );
    };
    window.addEventListener("scroll", saveScroll);
    return () => window.removeEventListener("scroll", saveScroll);
  }, [location.pathname]);

  useEffect(() => {
    const saved = sessionStorage.getItem(`scroll-pos-${location.pathname}`);
    const savedY = saved !== null ? parseInt(saved, 10) : NaN;

    setTimeout(() => {
      if (navType === "POP" && !Number.isNaN(savedY)) {
        window.scrollTo(0, savedY);
      } else {
        window.scrollTo(0, 0);
        setComponentFade([true, true, false, false, false, false, false]);
      }
    }, 0);
  }, [location.key, navType]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [componentFade]);

  if (isLoadingState) {
    return (
      <LoadingScreen
        txt={
          <span>
            매출 데이터를 <br /> 분석하고 있어요!
          </span>
        }
        subtxt={
          <span style={{ fontSize: "2.5vw", color: "grey" }}>
            최대 1분까지 걸릴 수 있어요!
          </span>
        }
      ></LoadingScreen>
    );
  } else if (
    !todayValue?.[props.page]?.today ||
    !todayValue?.[props.page]?.yesterday ||
    todayValue?.[props.page]?.today === undefined ||
    todayValue?.[props.page]?.today === undefined
  ) {
    return (
      <div className="block pt-5 overflow-x-hidden">
        <Header
          leftSide={openLeftSide}
          rightSide={openRightSide}
          currentDate={currentDate}
          page={page}
          t={t}
          i18n={i18n}
        ></Header>
        <motion.div
          className="fixed left-5 z-[9999]"
          initial={{ x: "-100%", opacity: 0 }}
          animate={{ x: leftSide ? 0 : "-100%", opacity: leftSide ? 1 : 0 }}
          exit={{ x: "-100%", opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <DropDownMenu
            sideList={sideList}
            changeLanguage={changeLanguage}
            open={openLeftSide}
            onclickFunction={scrollToContent}
            t={t}
            i18n={i18n}
          ></DropDownMenu>
        </motion.div>
        <motion.div
          className="fixed right-5 z-[9999]"
          initial={{ x: "+100%", opacity: 0 }}
          animate={{ x: rightSide ? 0 : "+100%", opacity: rightSide ? 1 : 0 }}
          exit={{ x: "+100%", opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <CalendarContent
            page={page}
            validDateList={validDateList}
            currentDate={currentDate}
            open={openRightSide}
            t={t}
            i18n={i18n}
            onSelectDate={(date) => {
              dispatch(totalThunks(date));
              dispatch(fetchRanking(date));
              openRightSide();
            }}
          ></CalendarContent>
        </motion.div>
        <NoData />
        <BottomNavbar
          page={page}
          pageType="reportIndex"
          currentDate={currentDate}
          t={t}
          i18n={i18n}
        ></BottomNavbar>
      </div>
    );
  } else {
    return (
      <div className="block pt-5 overflow-x-hidden">
        <Header
          leftSide={openLeftSide}
          rightSide={openRightSide}
          currentDate={currentDate}
          page={page}
          t={t}
          i18n={i18n}
        ></Header>
        <motion.div
          className="fixed left-5 z-[9999]"
          initial={{ x: "-100%", opacity: 0 }}
          animate={{ x: leftSide ? 0 : "-100%", opacity: leftSide ? 1 : 0 }}
          exit={{ x: "-100%", opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <DropDownMenu
            sideList={sideList}
            changeLanguage={changeLanguage}
            open={openLeftSide}
            onclickFunction={scrollToContent}
            t={t}
            i18n={i18n}
          ></DropDownMenu>
        </motion.div>
        <motion.div
          className="fixed right-5 z-[9999]"
          initial={{ x: "+100%", opacity: 0 }}
          animate={{ x: rightSide ? 0 : "+100%", opacity: rightSide ? 1 : 0 }}
          exit={{ x: "+100%", opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <CalendarContent
            page={page}
            validDateList={validDateList}
            currentDate={currentDate} // ← 리덕스 currentDate 사용
            open={openRightSide}
            t={t}
            i18n={i18n}
            onSelectDate={(date) => {
              dispatch(totalThunks(date));
              dispatch(fetchRanking(date));
              openRightSide();
            }}
          />
        </motion.div>
        <div className="py-4">
          <motion.div
            className="report-item"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            animate={{ opacity: componentFade[0] ? 1 : 0 }}
            transition={{ duration: 0.7 }}
          >
            <TodaySales
              page={page}
              value={todayValue}
              t={t}
              i18n={i18n}
            ></TodaySales>
          </motion.div>

          <motion.div
            key={`CompPredictSales-${page}`}
            className="report-item"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: componentFade[1] ? 1 : 0 }}
            // viewport={{ once: true }}
            animate={{ opacity: componentFade[1] ? 1 : 0 }}
            transition={{ duration: componentFade[1] ? 0.7 : 0 }}
          >
            <CompPredictSales
              page={page}
              currentDate={currentDate}
              value={predictValue}
              rankCompareValue={rankCompareValue}
              isVisible={componentFade[1]}
              predictvalue={predictValue}
              todayValue={todayValue}
              menuObject={menuObject}
              t={t}
              i18n={i18n}
            ></CompPredictSales>
          </motion.div>

          <motion.div
            className="report-item"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: componentFade[2] ? 1 : 0 }}
            viewport={{ once: true }}
            animate={{ opacity: componentFade[2] ? 1 : 0 }}
            transition={{ duration: 0.7 }}
          >
            <PredictSales
              currentDate={currentDate}
              page={page}
              isVisible={componentFade[2]}
              value={predictValue}
              menuObject={menuObject}
              rankCompareValue={rankCompareValue}
              t={t}
              i18n={i18n}
            ></PredictSales>
          </motion.div>
          <motion.div
            className="report-item"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: componentFade[3] ? 1 : 0 }}
            viewport={{ once: true }}
            animate={{ opacity: componentFade[3] ? 1 : 0 }}
            transition={{ duration: 0.7 }}
          >
            <BestMenu
              page={page}
              currentDate={currentDate}
              rankDetailValue={rankDetailValue}
              menuObject={menuObject}
              lastDetailValue={lastDetailValue}
              t={t}
              i18n={i18n}
            ></BestMenu>
          </motion.div>
          <motion.div
            className="report-item"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: componentFade[4] ? 1 : 0 }}
            viewport={{ once: true }}
            animate={{ opacity: componentFade[4] ? 1 : 0 }}
            transition={{ duration: 0.7 }}
          >
            <BiggestDiffMenu
              page={page}
              currentDate={currentDate}
              todayValue={rankDetailValue}
              lastDetailValue={lastDetailValue}
              menuObject={menuObject}
              t={t}
              i18n={i18n}
            ></BiggestDiffMenu>
          </motion.div>

          <motion.div
            className="report-item"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: componentFade[5] ? 1 : 0 }}
            viewport={{ once: true }}
            animate={{ opacity: componentFade[5] ? 1 : 0 }}
            transition={{ duration: 0.7 }}
          >
            <UserRank
              page={page}
              currentDate={currentDate}
              rankDetailValue={userRankDetail}
              menuObject={menuObject}
              t={t}
              i18n={i18n}
            ></UserRank>
          </motion.div>
          <motion.div
            className="report-item"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: componentFade[5] ? 1 : 0 }}
            viewport={{ once: true }}
            animate={{ opacity: componentFade[5] ? 1 : 0 }}
            transition={{ duration: 0.7 }}
          >
            <Newbie
              key={`newbie-${page}`}
              page={page}
              currentDate={currentDate}
              visitDetailValue={visitDetailValue}
              t={t}
              i18n={i18n}
            ></Newbie>
          </motion.div>
        </div>

        <BottomNavbar
          page={page}
          pageType="reportIndex"
          currentDate={currentDate}
          t={t}
          i18n={i18n}
        ></BottomNavbar>
      </div>
    );
  }
}

export default ReportPage;
